const config = {
  API_URL: 'https://tekstas.com/api'
};

export default config;